<!--
<template>
    <div class="register-form">
        <b-form @submit.prevent="registerClicked">
            <div v-show="userAlreadyTakenError" class="alert alert-danger">Username bereits vergeben</div>
            <div v-show="emailAlreadyTakenError" class="alert alert-danger">E-Mail bereits registriert.
                <router-link to="/login" class="btn btn-link">Zum Login</router-link>
            </div>
            <validation-input v-on:focus="resetErrors()" id="username" label="Username" v-model="username" :validation="validation" type="text" autocomplete="username"/>
            <validation-input v-on:focus="resetErrors()" id="password" label="Passwort" v-model="password" :validation="validation" type="password" autocomplete="new-password"/>
            <validation-input v-on:focus="resetErrors()" id="confirmPassword" label="Passwort wiederholen" v-model="confirmPassword" :validation="validation" :mustMatch="password" type="password" autocomplete="new-password"/>
            <validation-input v-on:focus="resetErrors()" id="email" label="E-Mail" v-model="email" :validation="validation" type="text" autocomplete="email"/>

            <div class="form-group">
                <button class="btn btn-primary">Registrieren</button>
                <p>Bereits registriert?
                    <router-link to="/login" class="btn btn-link">Zum Login</router-link>
                </p>
            </div>
        </b-form>
    </div>
</template>
-->
<template>
  <div class="login-parent">
    <section class="content">
      <div class="container">
        <div class="loginbox">
          <div class="login-leftside">
          </div>

          <b-form @submit.prevent="registerClicked">
            <h4> Willkommen bei Spoctitty </h4>
            <p> Heute ist ein guter Tag um fit zu bleiben!</p>
            <div v-show="userAlreadyTakenError" class="alert alert-danger">Username bereits vergeben</div>
            <div v-show="emailAlreadyTakenError" class="alert alert-danger">E-Mail bereits registriert.
              <router-link to="/login" class="btn btn-link">Zum Login</router-link>
            </div>
            <div style="height: 240px">
              <div class="logininput">
                <validation-input v-on:focus="resetErrors()" id="username" icon="heart" placeholder="Username"
                                  v-model="username" :validation="validation" type="text" autocomplete="username"/>
              </div>
              <div class="logininput">
                <validation-input v-on:focus="resetErrors()" icon="key" id="password" placeholder="Passwort" v-model="password"
                                  :validation="validation" type="password" autocomplete="current-password"/>
              </div>
              <div class="logininput">
                <validation-input v-on:focus="resetErrors()" icon="key" id="confirmPassword" placeholder="Passwort wiederholen" v-model="confirmPassword" :validation="validation" :mustMatch="password" type="password" autocomplete="new-password"/>
              </div>
              <div class="logininput">
                <validation-input v-on:focus="resetErrors()" icon="envelope" id="email" placeholder="E-Mail" v-model="email" :validation="validation" type="text" autocomplete="email"/>
              </div>
            </div>
            <div class="modalbuttons">
              <router-link to="/login" class="btn btn-link">Bereits registriert?</router-link>
              <button class="btn btn-primary">Registrieren</button>
            </div>
          </b-form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

    import {userService} from "../services/user.service";
    import {router} from "../core/router";
    import ValidationInput from "./shared/ValidationInput";

    export default {
        name: 'Register',
        components: {
            ValidationInput
        },
        data() {
            return {
                validation: {
                    submitted: false,
                    username: {
                        dirty: false,
                        required: true
                    },
                    password: {
                        dirty: false,
                        required: true,
                        requiredMessage: "Bitte Passwort angeben"
                    },
                    confirmPassword: {
                        dirty: false,
                        required: true,
                        mustMatchMessage: "Muss mit Passwort übereinstimmen",
                        requiredMessage: "Bitte Passwortbestätigung angeben"
                    },
                    email: {
                        dirty: false,
                        required: true,
                        email: true,
                        requiredMessage: "Bitte E-Mail angeben"
                    }
                },
                username: "",
                password: "",
                confirmPassword: "",
                email: "",
                userAlreadyTakenError: false,
                emailAlreadyTakenError: false
            }
        },
        methods: {
            registerClicked() {
                this.validation.submitted = true;
                if (this.username.length === 0 || this.password.length === 0) {
                    return;
                }
                const {username, password, email} = this;
                if (username && password && email) {
                    userService.register(username, password, email)
                        .then(() => {
                            this.showToast();
                            router.push({path: '/login'});
                        })
                        .catch((res) => {
                            this.validation.submitted = false;
                            if (res.response.code === 11) {
                                this.userAlreadyTakenError = true;
                            } else if (res.response.code === 13) {
                                this.emailAlreadyTakenError = true;
                            } else {
                                this.loginError = true
                            }
                        });

                }
            },
            resetErrors() {
                this.userAlreadyTakenError = false;
                this.emailAlreadyTakenError = false;
            },
            showToast() {
                this.$root.$bvToast.toast(`Bitte bestätigen Sie ihre Email Adresse`, {
                    title: 'Registrierung erfolgreich!',
                    autoHideDelay: 7000,
                    variant: "success"
                })
            }
        }
    }
</script>

<style scoped>
.login-parent {
  font-size: 14px;
  color: #2a3237;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 600px;

}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.loginheader {
  margin: 20px auto 0;
  text-align: center;
}

.loginheader a {
  margin-left: 10px;
  text-decoration: none;
  font-size: 18px;
  line-height: 25px;
  font-family: HighlandGothicFLF;
  color: black;
}

.loginheader img {
  vertical-align: middle;
}

.loginbox {
  display: flex;
  flex-direction: row;
  width: auto;
  height: auto;
  margin: auto auto;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 0px 96px -10px rgba(0, 0, 0, 0.75);
  overflow: hidden;
}

.loginbox .login-leftside {
  width: 200px;
  height: auto;
  min-height: 100%;
  background-image: url("https://images5.alphacoders.com/671/thumb-1920-671148.jpg");
  background-size: cover;
  transition: all 0.5s;
}

.loginbox form {
  padding: 40px 30px;
  background: #fefefe;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.loginbox form h3 {
  margin-bottom: 20px;
}

.loginbox form p {
  line-height: 155%;
  font-size: 14px;
  color: #000;
  opacity: .65;
  font-weight: 400;
  max-width: 200px;
  margin-bottom: 40px;
}

.loginbox form .logininput {
  position: relative;
  margin-bottom: 10px;
  width: 100%;
}

.loginbox form .logininput > div {
  border: none;
  box-shadow: none;
}

.loginbox form input {
  width: calc(100% - 44px);
  margin-left: auto;
  display: flex;
}

.loginbox form .logininput .loginicon {
  position: absolute;
  top: 0;
  left: 0;
  height: 56px;
  width: 44px;
  display: flex;
}

.loginbox form .logininput .loginicon i {
  height: 30px;
  width: 30px;
  margin: auto;
  transition: all .3s ease;
}

.loginbox form .modalbuttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.modalbuttons a {
  color: rgba(51, 51, 51, 0.6);
  font-size: 14px;
}

.loginbox form button {
  width: unset;
}

@media screen and (max-width: 768px) {

  .loginbox .login-leftside {
    width: 100px;
  }
}
</style>

